import { ErrorOutlineRounded } from '@mui/icons-material';
import AuthStatusPanel from 'pages/Auth/components/AuthStatusPanel';
import {
  authStatusPanelCompactDescriptionSx,
  authStatusPanelCompactTitleSx,
} from 'pages/Auth/components/AuthStatusPanel/AuthStatusPanel.styles';
import type { AuthErrorPanelProps } from './AuthErrorPanel.props';

const AuthErrorPanel = ({
  description,
  extraAction,
  icon,
  mainAction,
  title,
}: AuthErrorPanelProps) => (
  <AuthStatusPanel
    description={description}
    descriptionSx={authStatusPanelCompactDescriptionSx}
    extraAction={extraAction}
    icon={icon ?? <ErrorOutlineRounded fontSize="large" />}
    iconBackgroundColor="red.500"
    iconColor="neutral.white"
    mainAction={mainAction}
    title={title}
    titleSx={[authStatusPanelCompactTitleSx, { color: 'primary.main', fontWeight: 700 }]}
  />
);

export default AuthErrorPanel;
